import { IntendedUseEnum } from "./IntendedUses";

export interface DemoInstance {
  id: string;
  link: string;
  name: string;
  title: string;
  owner: string;
  group: string;
  creationDate: Date;
  expirationDate?: Date;
  password?: string;
  hdpUsername?: string;
  bWebAddress: string;
  powerState: PowerState;
  provisioningState: ProvisioningState;
  regionName: string;
  template: string;
  lastAccess: Date;
  available: boolean;
  powerStateText: string;
  prospect: string;
  prospectId: string;
  intendedUse: IntendedUseEnum | null;
  estimatedTime: number;
  linkSubHub: string;
  linkAdminPortal: string;
  comment: string;
  templateSuggested: boolean;
  boardVersion: string;
  relatedAssets: string[];
  canDelete?: boolean;
  snapshot?: DemoSnapshot;
}

export interface DemoSnapshot {
  snapshotLabel: string;
  snapshotDate?: Date;
  snapshotCreator: string;
  snapshotStatus: DemoSnapshotStatusEnum;
}

export enum PowerState {
  Online = "Online",
  Offline = "Stopped",
  Deleted = "Deleted",
  Deallocating = "Deallocating",
  Starting = "Starting",
  Stopping = "Stopping",
  Deleting = "Deleting",
  Creating = "Creating",
  Updating = "Updating"
}

export enum ProvisioningState {
  Completed = "Completed",
  Creating = "Creating",
  Updating = "Updating",
  Deleting = "Deleting",
  Stopping = "Stopping",
  Starting = "Starting"
}

// export enum InstanceState {
//   'Stopped for inactivity' = 0,
//   'Stopped for maintenance' = 1,
//   'Running' = 2,
//   'Started by customer' = 3,
//   'Dismissed' = 4,
//   'Suspended' = 5,
//   'Started for maintenance' = 6,
// }

export interface CreationInstanceProgress {
  minute: number;
  message: string;
}

export enum PowerStateComputed {
  Online = "Online",
  Offline = "Offline",
  Creating = "Creating",
  Deleting = "Deleting",
  Starting = "Starting",
  Updating = "Updating",
  SleepMode = "Sleep Mode"
}

export const PowerStateLookup = [
  { id: PowerStateComputed.Online, name: "Online" },
  { id: PowerStateComputed.Offline, name: "Offline" },
  { id: PowerStateComputed.Creating, name: "Creating" },
  { id: PowerStateComputed.Deleting, name: "Deleting" },
  { id: PowerStateComputed.Starting, name: "Starting" },
  { id: PowerStateComputed.Updating, name: "Updating" },
  { id: PowerStateComputed.SleepMode, name: "Sleep Mode" }
];

export const getPowerStatusTextDemoInstance = (
  powerState: PowerState | null,
  provisioningState: ProvisioningState,
  available: boolean
): string => {
  let status;
  switch (true) {
    case powerState === PowerState.Online && provisioningState === ProvisioningState.Completed:
      status = PowerState.Online;
      break;
    case powerState === PowerState.Deleted || powerState === PowerState.Offline:
      status = PowerStateComputed.Offline;
      break;
    case powerState === PowerState.Creating || provisioningState === ProvisioningState.Creating:
      status = PowerStateComputed.Creating;
      break;
    case powerState === PowerState.Deleting || provisioningState === ProvisioningState.Deleting:
      status = PowerStateComputed.Deleting;
      break;
    case (powerState === PowerState.Starting || powerState === PowerState.Online) &&
      provisioningState !== ProvisioningState.Creating &&
      provisioningState !== ProvisioningState.Completed:
      status = PowerStateComputed.Starting;
      break;
    case !powerState && provisioningState === ProvisioningState.Updating:
      status = PowerStateComputed.Updating;
      break;
    default:
      status = PowerStateComputed.SleepMode;
  }
  if (status === "Online" && !available) {
    status = PowerStateComputed.Creating;
  }

  return status;
};

export enum DemoSnapshotStatusEnum {
  creating = 0,
  ready,
  error
}
